<template>
  <div>
    <AdminChargeListFilters />

    <v-card outlined>
      <v-data-table
        :items="adminCharges"
        :headers="headers"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
      >
        <template v-slot:[`item.code`]="{ item }">
          <span class="font-weight-bold">
            {{ item.code }}
          </span>
        </template>
        <template v-slot:[`item.payer`]="{ item }">
          {{ handlePayerName(item.payer) }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="handleColors(handleChargeStatus(item.installments))"
            small
          >
            {{ $t(`charge.status.${handleChargeStatus(item.installments)}`) }}
          </v-chip>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <div class="d-flex align-center">
            {{ $t(`charge.types.${item.type}`) }}
            <v-tooltip v-if="item.type==='FCI'" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="grey lighten-1"
                  small
                  right
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>{{ $t('charge.hint.fciMeaning') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.appointment`]="{ item }">
          <span v-if="item.appointment" @click="toAppointmentDetails(item.appointment.id)" class="font-weight-medium primary--text clickable">
            {{ item.appointment.code }}
            <v-icon small color="primary">
              mdi-open-in-new
            </v-icon>
          </span>
          <span v-else>
            ---
          </span>
        </template>
        <template v-slot:[`item.value`]="{ item }">
          {{ item.value ? formatMoney(item.value) : '---' }}
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchAdminCharges" />
  </div>
</template>

<script>
import AdminChargeListFilters from './AdminChargeListFilters'

import { adminChargeTableHeaders } from '@/views/charge/listHeaders'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { mapActions, mapGetters } from 'vuex'
import { checkUserRole } from '@/util/helpers'
import { handleColors } from '@/util/colors'

export default {
  name: 'AdminChargeList',

  components: {
    AdminChargeListFilters
  },

  computed: {
    ...mapGetters(['adminCharges', 'isLoading', 'itemsPerPage']),
  },

  methods: {
    ...mapActions(['fetchAdminCharges']),

    handleChargeStatus(installments) {
      const status = installments.length && installments[0].status
      return status ? status : 'PENDING'
    },

    handleShowPayButton(status) {
      return status === 'PENDING'
    },

    handlePayerName(payer) {
      if (payer) {
        return payer.name
          ? payer.name
          : payer.real_estate
            ? payer.real_estate.name
            : '---'
      }
      return '---'
    },

    toAppointmentDetails(id) {
      this.$router.push(`../admin-appointment/${id}`).catch(() => {})
    },

    checkUserRole,
  },

  data() {
    return {
      headers: adminChargeTableHeaders,
      formatMoney: catalogMonetary,
      formatDate: catalogDate,
      charge: null,
      handleColors,
    }
  },

  mounted() {
    if (!checkUserRole(['ROLE_SUPPORT'])) this.fetchAdminCharges()
  },
}
</script>
